import { Translations } from '@typings';

import { DEFAULT_LANGUAGES_CODES } from '../constants/translation';
import { formatLocaleDate, formatLocaleDateAndTime } from '../utils/dates';
import { isDefined } from '../utils/is';

import i18n from './i18n';

export const updateSupportedLanguages = (additionalLanguagesCodes: Translations.AdditionalLanguagesCodes[] | undefined) => {
  i18n.init({
    supportedLngs:
      isDefined(additionalLanguagesCodes) ? [...DEFAULT_LANGUAGES_CODES, ...additionalLanguagesCodes] : DEFAULT_LANGUAGES_CODES,
  });
};

export const addFormatters = () => {
  i18n.services.formatter?.add('date', (date, locale) => formatLocaleDate(date, locale as Translations.SupportedLanguagesCodes));
  i18n.services.formatter?.add('dateAndTime', (date, locale) =>
    formatLocaleDateAndTime(date, locale as Translations.SupportedLanguagesCodes),
  );
};
